/* eslint-disable */ /* THIS FILE HAS BEEN GENERATED. DO NOT EDIT IT. */ import { jsx as _jsx } from "react/jsx-runtime";
import { createIcon } from '../';
// prettier-ignore
const CheckCircleOutlinedIcon = createIcon({
    displayName: 'CheckCircleOutlinedIcon',
    viewBox: '0 0 24 24',
    pathSmall: [
        /*#__PURE__*/ _jsx("path", {
            d: "m11.109 12.996 2.905-4.303 1.104.746-3.732 5.53-3.248-2.723.856-1.023 2.115 1.773Z"
        }),
        /*#__PURE__*/ _jsx("path", {
            fillRule: "evenodd",
            d: "M4 12c0-5.138 2.862-8 8-8 5.137 0 8 2.862 8 8 0 5.137-2.863 8-8 8-5.138 0-8-2.863-8-8Zm1.333 0c0 4.424 2.243 6.667 6.667 6.667 4.424 0 6.667-2.243 6.667-6.667 0-4.424-2.243-6.667-6.667-6.667-4.424 0-6.667 2.243-6.667 6.667Z",
            clipRule: "evenodd"
        })
    ],
    pathMedium: [
        /*#__PURE__*/ _jsx("path", {
            d: "M11.456 13.45 15.813 7l1.658 1.12-5.599 8.288L7 12.326l1.284-1.533 3.172 2.658Z"
        }),
        /*#__PURE__*/ _jsx("path", {
            fillRule: "evenodd",
            d: "M1 12C1 4.936 4.936 1 12 1s11 3.936 11 11-3.936 11-11 11S1 19.064 1 12Zm2 0c0 5.972 3.028 9 9 9 5.972 0 9-3.028 9-9 0-5.972-3.028-9-9-9-5.972 0-9 3.028-9 9Z",
            clipRule: "evenodd"
        })
    ]
});
CheckCircleOutlinedIcon.defaultProps = {
    fill: 'currentColor',
    boxSize: '24px',
    display: 'block',
    ['data-testid']: 'CheckCircleOutlinedIcon'
};
export { CheckCircleOutlinedIcon };

//# sourceMappingURL=check-circle_outlined.js.map